import React, {useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Input from "../../../components/Input";
import Button from "../../../components/Button"

import { 
    Container, 
    FirstColumn, 
    Title, 
    SubText, 
    RadioButtonRow, 
    RadioButtonForm, 
    RadioButtonContainer, 
    RadioButtonContent,
    RadioButtonDescription,
    SecondColumn,
    PixKeyContainer,
    TitleAndTrashContainer,
    ButtonContainer 
} from "./styles";

import routes from "../../../routes/pix.routes";

//Assests
import trash from "../../../assets/icons/trash.svg";
import examplePix from "../../../assets/img/example-pix.svg"

const MyKeys = () => {
    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();

    const formValidationWithYup = Yup.object().shape({
        pixKey: Yup.string().required()
    })
    
    useEffect(() => {
        if(login.user.groups.cm7a1 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const pixKeysGenerator = () => {
        const keys = [
            {
                type: "CPF",
                number: "15584516519"
            },
            {
                type: "Aleatória",
                number: "82264fc6-1ad6-4ad0-b57b-a5fce9ffd3cc"
            }
        ];

        return keys.map((key, index) => {
            return (
                <PixKeyContainer key={index} >
                    <TitleAndTrashContainer>
                        <Title style={{marginBottom: 0}}>{key.type}</Title>
                        <img src={trash} style={{height: 19}}/>
                    </TitleAndTrashContainer>
                    <SubText style={{marginBottom: 9}}>{key.number}</SubText>
                </PixKeyContainer>
            )
        })
    }

    return (
        <div>
            <Header title="PIX" subTitle="Crie suas chaves PIX e faça suas cobranças" subTitleWidth={200}/>
            <NavTabs tabs={routes}/>

                <Container>
                    <FirstColumn>
                        <Title>Instruções</Title>
                        <SubText>❖ O comprador pagará a sua compra por meio do Pix para a adquirente.</SubText>
                        <SubText>❖ O valor será transferido para a conta do Adquirente.</SubText>
                        <SubText>Atenção: aparecerá o nome do adquirente no momento do pagamento, conforme o exemplo ao lado.</SubText>
                        <SubText>❖ O Adquirente fará o repasse dos valores em D+1. Isso quer dizer que o recebimento do pagamento não será instantâneo, será em D+1 apenas em dias úteis, semelhante a experiência do Boleto que são liquidadas em D+1. Em resumo, se o Comprador fizer um pagamento na quarta-feira até 00h00, o valor estará disponível no dia seguinte, quinta-feira após às 14h, mas caso a transação seja feita a partir de 00h01, o recebimento será sexta-feira após às 14h, mas lembre-se, o comprador continua com o mesmo benefício de comprar com o Pix: é prático, seguro e sem custo.</SubText>
                    </FirstColumn>

                    <SecondColumn>
                        <Title>Exemplo:</Title>


                        <div className="d-flex justify-content-center justify-content-sm-start justify-content-md-start justify-content-lg-start justify-content-xl-start">
                            <img style={{width: 300, height: 500, marginBottom: 10}} src={examplePix} alt="exemplo pix"/>
                        </div>
                    </SecondColumn>

                </Container>

        </div>
    )
}

export default MyKeys;